(function ($) {
   // Shared utilities
   function applyEqualHeights(section) {
      function equalTitleHeights() {
         const $titles = $(section).find('.item-title');
         if ($titles.length > 0) {
            $titles.css('height', 'auto').equalHeights();
         }
      }
      $(window).on('resize', $.debounce(100, equalTitleHeights));
      equalTitleHeights();
   }

   function randomizeSlides(swiperEl, id, limitProducts) {
      const swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
      const slides = window.slides[id];
      if (!swiperWrapper || !slides || !slides.length) return;

      let slidesCopy = [...slides];

      // Fisher-Yates shuffle
      for (let i = slidesCopy.length - 1; i > 0; i--) {
         const j = Math.floor(Math.random() * (i + 1));
         [slidesCopy[i], slidesCopy[j]] = [slidesCopy[j], slidesCopy[i]];
      }

      if (limitProducts) {
         slidesCopy = slidesCopy.slice(0, limitProducts);
      }

      swiperWrapper.innerHTML = slidesCopy.join('');
   }

   // Main carousel initialization
   class ResponsiveCarousel {
      constructor(section) {
         this.section = section;
         this.swiper = null;
         this.elements = {
            container: section.querySelector('.section-container'),
            swiperEl: section.querySelector('.swiper'),
            prevBtn: section.querySelector('.swiper-prev'),
            nextBtn: section.querySelector('.swiper-next'),
         };

         if (!this.elements.container) return;

         this.settings = JSON.parse(this.elements.container?.dataset.settings || '{}');
         this.init();
      }

      init() {
         // Handle randomization
         if (this.settings.randomize_slides) {
            randomizeSlides(this.elements.swiperEl, this.settings.id, this.settings.limit_products);
            this.elements.container.classList.remove('hide-content');
         }

         // Set up responsive behavior
         this.handleResponsive();
         $(window).on(
            'resize',
            $.debounce(100, () => this.handleResponsive())
         );

         // Apply equal heights if needed (works regardless of swiper state)
         if (this.settings.titles_equal_height) {
            applyEqualHeights(this.section);
         }
      }

      handleResponsive() {
         // Check if responsive behavior is enabled
         if (!this.settings.disable_above) {
            // Always initialize if responsive behavior is not enabled
            if (!this.swiper) {
               this.initSwiper();
            }
            return;
         }

         // Use custom breakpoint or default to 767
         const breakpoint = this.settings.disable_above_width || 767;
         const enableSwiper = window.innerWidth <= breakpoint;

         if (enableSwiper && !this.swiper) {
            this.initSwiper();
         } else if (!enableSwiper && this.swiper) {
            this.destroySwiper();
         }
      }

      initSwiper() {
         const { swiperEl, prevBtn, nextBtn } = this.elements;

         this.swiper = new Swiper(swiperEl, {
            loop: false,
            slidesPerView: 'auto',
            navigation: {
               nextEl: nextBtn,
               prevEl: prevBtn,
            },
            on: {
               // init: swiper => this.updateButtonStates(swiper),
               // slideChange: swiper => this.updateButtonStates(swiper),
            },
         });

         this.elements.container.classList.remove('swiper-disabled');
         this.elements.container.classList.add('swiper-enabled');
      }

      destroySwiper() {
         if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
            this.resetButtonStates();

            this.elements.container.classList.remove('swiper-enabled');
            this.elements.container.classList.add('swiper-disabled');
         }
      }

      // updateButtonStates(swiper) {
      //    const { prevBtn, nextBtn } = this.elements;

      //    // Update prev button
      //    if (prevBtn) {
      //       console.log('update prev button, swiper.isBeginning: %o', swiper.isBeginning);
      //       prevBtn.classList.toggle('swiper-button-disabled', swiper.isBeginning);
      //       prevBtn.toggleAttribute('disabled', swiper.isBeginning);
      //    }

      //    // Update next button
      //    if (nextBtn) {
      //       console.log('update next button swiper.isEnd: %o', swiper.isEnd);
      //       nextBtn.classList.toggle('swiper-button-disabled', swiper.isEnd);
      //       nextBtn.toggleAttribute('disabled', swiper.isEnd);
      //    }
      // }

      resetButtonStates() {
         const { prevBtn, nextBtn } = this.elements;

         [prevBtn, nextBtn].forEach(btn => {
            if (btn) {
               btn.classList.remove('swiper-button-disabled');
               btn.removeAttribute('disabled');
               btn.classList.add('swiper-button-lock');
            }
         });
      }
   }

   // Initialize all carousels
   document.querySelectorAll('.section-swiper-carousel:not(.initialized)').forEach(section => {
      if (section.children.length) {
         section.classList.add('initialized');
         new ResponsiveCarousel(section);
      }
   });
})(jQuery);
